import React from "react";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function BubbleGridChart({
    title = "Horizontal Heat Bar Chart",
    data = [],  // [{ district: "Nanded", value: 45 }]
}) {
    const height = 300; // 🔥 FIXED HEIGHT

    // Sort high → low
    const sorted = [...data].sort((a, b) => b.value - a.value);

    const labels = sorted.map((item) => item.district);
    const values = sorted.map((item) => item.value);

    // Heat scale
    const getColor = (v) => {
        if (v < 10) return "#8bcf69";
        if (v < 20) return "#c4d96c";
        if (v < 30) return "#e8b063";
        if (v < 40) return "#e37b5f";
        return "#d9534f";
    };

    const backgroundColors = sorted.map((item) => getColor(item.value));

    // Chart Data
    const chartData = {
        labels,
        datasets: [
            {
                data: values,
                backgroundColor: backgroundColors,
                borderWidth: 0,
                barThickness: 20,
            }
        ]
    };

    // Options
    const options = {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false, // ❗ important for fixed height
        scales: {
            x: {
                ticks: { display: false },
                grid: { display: true, color: "#e2e8f0" },
            },
            y: {
                ticks: { color: "#475569", font: { size: 11 } },
                grid: { display: false },
            }
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: "#fff",
                borderColor: "#e2e8f0",
                borderWidth: 1,
                titleColor: "#1e293b",
                bodyColor: "#1e293b",
                cornerRadius: 10,
                padding: 10,
                callbacks: {
                    label: (ctx) => `${ctx.label}: ${ctx.raw}`,
                }
            },
            datalabels:false
        }
    };

    return (
        <div className="bg-white rounded-xl shadow-md p-4">

            {/* Header */}
            <div className="flex justify-between items-center mb-3">
                <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
                <i className="fa fa-chart-bar text-slate-500 text-lg" />
            </div>

            {/* Chart */}
            <div style={{ height: `${height}px` }}>
                <Bar data={chartData} options={options} />
            </div>

            {/* Legend */}
            <div className="flex justify-between items-center mt-3 text-xs text-slate-600">
                <div className="flex items-center gap-1">
                    <div className="w-3 h-3 rounded-sm" style={{ background: "#8bcf69" }}></div>
                    <span>0 - 10</span>
                </div>
                <div className="flex items-center gap-1">
                    <div className="w-3 h-3 rounded-sm" style={{ background: "#c4d96c" }}></div>
                    <span>10 - 20</span>
                </div>
                <div className="flex items-center gap-1">
                    <div className="w-3 h-3 rounded-sm" style={{ background: "#e8b063" }}></div>
                    <span>20 - 30</span>
                </div>
                <div className="flex items-center gap-1">
                    <div className="w-3 h-3 rounded-sm" style={{ background: "#e37b5f" }}></div>
                    <span>30 - 40</span>
                </div>
                <div className="flex items-center gap-1">
                    <div className="w-3 h-3 rounded-sm" style={{ background: "#d9534f" }}></div>
                    <span>40+</span>
                </div>
            </div>

        </div>
    );
}
